import React from 'react';
import {
  DateInput,
  FilterForm,
  FilterButton,
  SearchInput,
  SelectInput,
  useListContext
} from 'react-admin';
import { Stack } from '@mui/material';
import { styled } from '@mui/material/styles';

import type { RepairFilterType } from '@src/types';

// Apply styles to the FilterButton so it looks/behaves like other buttons
// This is more for future style alignment if we decide to use ExportButton for example
const StyledFilterButton = styled(FilterButton)({
  display: 'inline-flex',
  alignItems: 'center',
  '& .MuiButton-root': {
    width: '100%',
    height: '100%',
    padding: '0 16px'
  },
});

// Component that renders filters with access to list context
const RepairListToolbar = () => {
  const { meta } = useListContext();
  // assertion here to handle React Admin's generic approach to dataProviders
  const repairFilters = meta?.filters as RepairFilterType | undefined;

  const inputs = [
    <SearchInput key="search" source="searchQuery" placeholder="Search repairs..." alwaysOn />,
  ];

  // Add status filter if available
  if (repairFilters?.validStates) {
    const statusChoices = repairFilters.validStates.map(state => ({
      id: state.code,
      name: state.name,
    }));

    inputs.push(
      <SelectInput
        key="status"
        source="state"
        label="Status"
        choices={statusChoices}
        alwaysOn
        resettable
        sx={{ width: '150px' }}
      />
    );
  }

  // Add repair type filter if available
  if (repairFilters?.validProblems) {
    const typeChoices = repairFilters.validProblems.map(problem => ({
      id: problem.code,
      name: problem.name,
    }));

    inputs.push(
      <SelectInput
        key="repairType"
        source="repairAttributes.problem"
        label="Repair Type"
        choices={typeChoices}
        alwaysOn
        resettable
        sx={{ width: '150px' }}
      />
    );
  }

  // Add date range filters
  inputs.push(
    <DateInput
      key="initiatedAfter"
      source="initiatedAfter"
      label="Initiated Start Date"
      alwaysOn
    />,
    <DateInput
      key="initiatedBefore"
      source="initiatedBefore"
      label="Initiated End Date"
      alwaysOn
    />
  );

  return (
    <>
      <Stack direction="row" paddingLeft={2} paddingRight={2}>
        <FilterForm filters={inputs} style={{ backgroundColor: 'pink' }} />
        <StyledFilterButton filters={inputs} />
      </Stack >
    </>
  );
};

export default RepairListToolbar;
